// extracted by mini-css-extract-plugin
module.exports = {"button":"dece2e673c--button--DsA7r"};